import React, { Component } from 'react';
//import { Redirect } from 'react-router';

import { /*isAfterDate,*/ hasPerm, revealPrompts, reviseTUser, loadBallot, updateBallot, getTournamentValues, stopTimer, putToast, /*loadObjectWith,*/ AuthenticatedUser } from "../../api"
import TournamentPageTemplate from './tournamentPageTemplate'
import {Link} from 'react-router-dom'
import { Button} from 'reactstrap';
import ModalWindow from "../../common/modalWindow"
import PageCloser from "../../common/pageCloser"
import moment from 'moment';

import Countdown from '../../common/countdown'
import ballotConfigs from './ballot/ballotConfigurations'

const _ = require("lodash");


class TournamentBallot extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;
        this.onSubmitBallotClicked = this.onSubmitBallotClicked.bind(this);
        this.onSubmitBallotCancelled = this.onSubmitBallotCancelled.bind(this);
        this.onSubmittedBallotCancelled = this.onSubmittedBallotCancelled.bind(this);
        this.onSubmitBallotConfirmed = this.onSubmitBallotConfirmed.bind(this);
        this.onUpdateContents = this.onUpdateContents.bind(this);
        this.onBallotChange = this.onBallotChange.bind(this);
        this.onRevealPrompts = this.onRevealPrompts.bind(this);
        this.enterFatalErrorState = this.enterFatalErrorState.bind(this);
        
        this.toCompetitors = null;
        this.reasons = [];
        this.bConfig = {};

        this.state = {
            loading: true,
            openSubmit: false,
            openSubmitted: false,
            user: user,
            tData: {},
            pid: params.pid,
            roomId: params.roomId,
            judgeId: params.judgeId,
            competitorId: params.competitorId,
            tRoom: null,
            rEvent: null,
            tRound: null,
            tEvent: null,
            tCompetitor: null,
            ballot: {},
            allPoints: [],
            backToHome: false,
            fatalErrorHeader: null,
            fatalError: null
        }
    }

    loadTournamentPage = async (pid) => {  
        const {roomId} = this.state;

        if (this.state.pid) {
            loadBallot(this.state.pid, roomId, this.state.judgeId, this.state.competitorId ? this.state.competitorId : "0").then( d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    const {tRound, rEvent, tRoom} = getTournamentValues(d2.tournamentPage, roomId);
                    const tEvent = d2.tournamentPage.events.find(x=>x && x._id === rEvent.eventId)
                    const allPoints = this.setAllPoints(d2.ballot);
                    this.selectBallotDetails(d2.ballot) 
                    this.setState({ allPoints: allPoints, ballot: d2.ballot, content: d2.ballot.content ? JSON.parse(d2.ballot.content) : {},
                    rercPromptStatuss: d2.rercPromptStatuss,
                    tData: d2.tournamentPage, tUser: d2.tUser, tEvent: tEvent, tRoom: tRoom, rEvent: rEvent, tRound: tRound, loading: false}); 
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount(){
        this.loadTournamentPage();  
        // update every second
        
        this.serverInterval = setInterval(() => {
            this.saveBallot("timer");
          }, 50000);    

                  
        this.localInterval = setInterval(() => {
            this.updateClocks("timer");
          }, 1000); 
    }
/*
    componentDidMount() {
        // update every second
        this.interval = setInterval(() => {
          const date = this.calculateCountdown(this.props.date);
          date ? this.setState(date) : this.stop();
        }, 1000);
      }
*/    
      componentWillUnmount() {
        clearInterval(this.serverInterval);
        clearInterval(this.localInterval);
    }


    updateClocks() {
        this.setState({ ballot: this.state.ballot}); 
             
    }


    setAllPoints(ballot) {
        const allPoints = [];
        for(const competitor of ballot.competitors) {
            const content = competitor.content ? JSON.parse(competitor.content) : {}
            allPoints.push(content.points);
        }

        return allPoints;
    }

    selectBallotDetails(ballot) {
        if (ballot && ballot.eventAbbr) { this.bConfig = ballotConfigs[ballot.eventAbbr]; }
    }

    saveBallot(successMessage="Saved") {
        if (this.state.fatalError) return;

        const {tData, ballot, tUser, user} = this.state;
        if ((this.state.user._id !== ballot.judgeUserId) && !hasPerm(user, tData.permTags[0])) return;

        var that=this;
        clearTimeout(this.toCompetitors);
        this.toCompetitors = setTimeout(function () {
            const values = { isSubmitted : ballot.isSubmitted, content: ballot.content, competitors: ballot.competitors, __v: ballot.__v }
            updateBallot( tData._id, values, ballot._id).then(d2 => {

                if (d2 && d2.error) {
                    console.log(d2.error);
                    if (d2.error === "Conflict")
                    {
                        that.enterFatalErrorState("Ballot Edited From Another Browser", "This ballot has been updated from another device or browser tab. If you wish to continue working here, please refresh the page to see the latest version of the ballot. If you have made changes that you wish to keep on the other device or browser tab, please copy and paste your content to a document on your computer before refreshing to prevent loss of work.");
                    } else {
                        try { putToast.error(d2.error) } catch(_) {} // best effort to show error without crashing
                    }
                } else {
                    if (successMessage !== 'timer') putToast.info(successMessage);

                    if (successMessage === 'Submitted') {
                        const tUserRound = tUser.rounds.find(x=>x.roundId === ballot.roundId);
                        const tUserRoundEvent = tUserRound.events.find(x=>x.eventId === ballot.eventId);
                        const tUserRoundEventRoom = tUserRoundEvent.rooms.find(x=>x.roomId === ballot.roomId);
                        tUserRoundEventRoom.hasCompleted = true;
                        tUser.status = 'hasCompleted'; // TODO: seems unneeded
                
                        reviseTUser(tUser).then(d3 => {
                            if (!d3 || d3.error) {
                                console.log(d3 ? d3.error : "Error - no data");
                                putToast.error(d3 ? d3.error : "Error - no data");
                            } else {
                                that.setState({ tUser: d3.tUser, ballot: d2.ballot, rercPromptStatuss: d2.rercPromptStatuss, });   
                                putToast.success(d3.message);
                            }
                        }); 
                    } else {
                        that.setState({ ballot: d2.ballot, rercPromptStatuss: d2.rercPromptStatuss});
                    }
                }
            });            
        }, 2000);        
    }

    onSubmitBallotClicked() {
        this.setState({openSubmit: true })
    }

    onSubmitBallotCancelled() {
        this.setState({openSubmit: false })
    }

    onSubmittedBallotCancelled() {

        this.setState({openSubmitted: false, backToHome: true })
        this.props.history.push(`/pages/tournament/${this.state.tData._id}`)

    }

    onSubmitBallotConfirmed() {
        // submit and take judge to main page.
        if (this.state.user._id === this.state.ballot.judgeUserId) {
            this.state.ballot.isSubmitted = true;
            this.saveBallot("Submitted")
            this.setState({openSubmit: false, openSubmitted: true  })
        }
    }

    // for stars
    onUpdateContents(competitor, content, rankOnly) {
        const {ballot} = this.state;
        const c = ballot.competitors.find(x=>x.userId === competitor.userId);
        c.content = content;


        var allPoints = this.state.allPoints;
        if (!rankOnly) allPoints = this.setAllPoints(ballot);

        this.setState({ballot: ballot, allPoints: allPoints})

        if (this.state.user._id === this.state.ballot.judgeUserId && !this.state.ballot.isSubmitted) this.saveBallot();        
    }

    // for other elements
    onBallotChange(evt) {
        var id = evt.target.id

        const val = evt.target.value
        let state = this.state;

        state.content[id] = val;
        state.ballot.content = JSON.stringify(this.state.content)
        this.setState(state);

        if (this.state.user._id === this.state.ballot.judgeUserId && !this.state.ballot.isSubmitted) this.saveBallot();
    }

    isValid(value) {
        if (typeof value === 'undefined') return false;
        if (typeof value === 'number' && value === 0) return false;

        return !( value === "" || !  /$/.test(value))
    }
    
    isValidReason(value) {
        if (typeof value === 'undefined') return false;
        if (value.length < 100) return false;
        
        return !( value === "" || !  /$/.test(value))
    }

    approveItem(item, message) {
        if (item) return true;
        
        this.reasons.push(message)
        return false;
    }

    getApprovable(state) {
        if (state.tEvent.teamSize > 1) {return this.getApprovableDUO(state); }
        return this.getApprovableSTD(state);
    }

    getApprovableSTD(state) {
        var approvable = true;
    
        if (state && this.bConfig.renderer) {
            this.reasons = [];
            const compCount = state.ballot.competitors.length;

            if (this.bConfig.needsDecision) {
            // decision
                approvable &= this.approveItem(this.isValid(state.content.decision), `Must decide between ${this.bConfig.roles.map(x => x[1]).join(" and ")} as the winner`)
            }

            //approvable &= this.approveItem(this.isValidReason(state.content.comments), `It is very helpful to the competitors if you provide more content in the 'reason' field. (min 100 characters)`)

            // ranks
            const ranks = [0,0,0,0,0,0,0,0,0]
            for (var i = 0; i < compCount; i++) {
                const c = state.ballot.competitors[i]
                const content = c.content ? JSON.parse(c.content) : {}
                if (content.rank) { ranks[Number(content.rank)] = 1 }
                const competitor = state.tRoom.competitors.find(x => x.userId === c.userId);
                approvable = this.approveItem(this.isValid(content.rank), `Must set a rank for ${competitor.displayname}`) & approvable
    
                // each characteristic
                for (const characteristic of this.bConfig.characteristics) {
                    if (characteristic.group && !characteristic.title) approvable &= true;
                    else approvable &= this.approveItem(this.isValid(content[characteristic.key]), `Must set a ${characteristic.title} value for ${competitor.displayname}`)
                }
            }
            approvable &= this.approveItem(((ranks[1] + ranks[2] + ranks[3] + ranks[4] + ranks[5] + ranks[6] + ranks[7] + ranks[8]) === compCount), `Each competitor must have a unique rank - change the points accordingly`)
        }
    
        return approvable;
    }

    getApprovableDUO(state) {
        var approvable = true;
    
        if (state && this.bConfig.renderer) {
            this.reasons = [];
            const compCount = state.ballot.competitors.length / 2;

            if (this.bConfig.needsDecision) {
            // decision
                approvable &= this.approveItem(this.isValid(state.content.decision), `Must decide between ${this.bConfig.roles.map(x => x[1]).join(" and ")} as the winner`)
            }

            //approvable &= this.approveItem(this.isValidReason(state.content.comments), `It is very helpful to the competitors if you provide more content in the 'reason' field. (min 100 characters)`)

            // ranks
            const ranks = [0,0,0,0,0,0,0,0,0]
            for (var i = 0; i < state.ballot.competitors.length; i+=2) {
                const c = state.ballot.competitors[i]
                const content = c.content ? JSON.parse(c.content) : {}
                if (content.rank) { ranks[Number(content.rank)] = 1 }
                const competitor = state.tRoom.competitors.find(x => x.userId === c.userId);
                approvable = this.approveItem(this.isValid(content.rank), `Must set a rank for ${competitor.displayname}`) & approvable
    
                // each characteristic
                for (const characteristic of this.bConfig.characteristics) {
                    if (characteristic.group && !characteristic.title) approvable &= true;
                    else approvable &= this.approveItem(this.isValid(content[characteristic.key]), `Must set a ${characteristic.title} value for ${competitor.displayname}`)
                }
            }
            approvable &= this.approveItem(((ranks[1] + ranks[2] + ranks[3] + ranks[4] + ranks[5] + ranks[6] + ranks[7] + ranks[8]) === compCount), `Each competitor must have a unique rank - change the points accordingly`)
        }
    
        return approvable;
    }

    onRevealPrompts(competitor) {
        const {tData, tRound, rEvent, tRoom , rercPromptStatuss} = this.state;
        revealPrompts(competitor.userId, tRoom._id, rEvent.eventId, tRound._id, tData._id).then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
            } else {
                putToast.info(d2.message);
                const newStatus = rercPromptStatuss.find(x=>x._id === d2.rercPromptStatus._id);
                _.extend(newStatus, d2.rercPromptStatus);
                this.setState({ rercPromptStatuss });   
            }
        });
    }

    
    enterFatalErrorState = (header, message) => {
      try {
        clearInterval(this.serverInterval);
        clearInterval(this.localInterval);
        clearTimeout(this.toCompetitors);
      } catch (_) {}
      this.toCompetitors = null;
      this.setState({ fatalErrorHeader: header || "Something Went Wrong", fatalError: message || "An unexpected error occurred." });
    }


    render() {
        if (this.state.loading) { return null; }

        if (this.state.fatalError) {
            return (
                <div className="container-fluid" style={{ padding: '24px' }}>
                    <div className="row">
                        <div className="col-12">
                            <div style={{ border: '1px solid #f5c6cb', background: '#f8d7da', color: '#721c24', borderRadius: 4, padding: '16px' }}>
                                <h4 style={{ marginTop: 0 }}>{this.state.fatalErrorHeader}</h4>
                                <p style={{ marginBottom: 12 }}>{this.state.fatalError}</p>
                                <button type="button" className="btn btn-danger" onClick={() => window.location.reload()}>Refresh Page</button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
/*
        if (this.state.backToHome) {
            return <Redirect push to={`/pages/tournament/${this.state.tData._id}`} />;
        }
*/
        
        const {tData, tEvent, tRound, tRoom, rEvent, user, ballot, content, rercPromptStatuss} = this.state;
        var decision = ''
        var winners = [];
        if (this.bConfig.needsDecision) {
            const decisionItem = this.bConfig.roles.find(x => x[0] === content.decision);
            decision = decisionItem ? decisionItem[1] : '';
            winners = tRoom.competitors.filter(x=>x.role === decision);
        }
        //const tRound = tData.rounds.find(x=>x._id === ballot.roundId);
        const dueDate = moment(tRound.dueDate);

        /*
        const isJudgeInRoom = tRoom.judges.find(x=>x.userId === tUser.userId);
        const isUserJudge = tUser.isJudge;
        const isUserThisRoomsJudge = isUserJudge && isJudgeInRoom;
        */

/*      TODO: Use this version for after tournament ballot viewing - turn this into a tp setting
        var viewable =  hasPerm(user, tData.permTags[0]) || 
                        (!ballot.isSubmitted && user._id === ballot.judgeUserId) || 
                        (ballot.competitors.find(x=>x.userId ===user._id) && isAfterDate(new Date(), new Date(tData.endDate))) ;
*/

        // TODO: use this version for after round viewing - turn this into a tp.setting
        var viewable =  hasPerm(user, tData.permTags[0]) || 
                        (!ballot.isSubmitted && user._id === ballot.judgeUserId) || 
                        (ballot.competitors.find(x=>x.userId ===user._id) && tRound.status === 'closed') ;

                        //const judge = this.state.tUsers.find(x=>x.userId === ballot.judgeUserId);
        //const judgeDisplayname = judge ? judge.displayname : "Unknown"
        var locked = (this.state.user._id !== ballot.judgeUserId) && !hasPerm(user, tData.permTags[0]);

        stopTimer();
        return (
            <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2=""                
            title3=
            {<>
            <div className="row">
                <div className="col-12">
                    <h4><Link to={`/tournament/room/${tData._id}/${tRoom._id}`} >{tRoom.title}</Link> - {tEvent.title} - {tRound.title} 
                        {locked && <> - Locked</>}
                        <div className="pull-right">
                            <span>Judge: {ballot.judgeDisplayname || "Unknown"}</span>
                        </div>
                    </h4>
                </div>
            </div>
            {tRoom.resolution &&
            <div className="row">
                <div className="col-12">
                    <h4>Resolution: {tRoom.resolution ? tRoom.resolution : 'To be revealed ...'}</h4>
                </div>
            </div>            
            }
            <div className="row">
                <div className="col-12">
                    <p style={{color: "red"}}>Warning: You may wish to copy and paste content from a document on your computer to prevent extra work in case of network connection issues.</p>
                </div>
            </div> 

            </>
            }
                bcTitle="Ballot" bcParents={[{name: tData.title, url: `/pages/tournament/${tData._id}`}]}
            >
                {viewable
                ?
                <div className="container-fluid"> 
                    <div className="row">
                        <div className="col-12">
                            {hasPerm(user, tData.permTags[0]) && <button type="button" className="btn btn-primary pull-right" onClick={() => this.saveBallot()} style={{margin: "6px"}}>Save</button>}                            
                            {ballot.isSubmitted ? null : <div className="pull-right"><strong >Please submit ballot within: </strong><Countdown small date={new Date(dueDate)} /></div>}
                        </div>
                    </div>

                    {this.bConfig.renderer && this.bConfig.renderer(this, this.state.allPoints, ballot, locked, content, rercPromptStatuss, rEvent)}
                    
                    <br />
                    <br />
                    <div className="row align-self-center text-center">
                        <div className="col-lg-12 col-sm-12">
                            <Button disabled={locked || !this.getApprovable(this.state)} className="btn btn-solid" onClick={this.onSubmitBallotClicked} >Submit Ballot</Button>
                        </div>
                    </div>                    

                    {this.reasons.length > 0 &&
                    <div className="row align-self-center text-center">
                        <div className="col-lg-12 col-sm-12">
                            <h5>To submit, please attend to the following situations ...</h5>
                            {this.reasons.map(x=>
                            <div ><p style={{fontSize: "14px", color: "red", lineHeight: "1.2em"}}>{x}</p></div>
                            )}

                        </div>                               
                    </div>
                    }
                    <br/>
                    <br/>
                                          
                </div>
                :   
                <PageCloser 
                    header="This ballot has been submitted and is no longer accessible."
                    message={<Link to={`/pages/tournament/${this.state.tData._id}`}>Click here to return to the tournament main page.</Link>}
                 />
                }    
                <ModalWindow title="Confirm Ballot Submission ..." open={this.state.openSubmit} onCancel={this.onSubmitBallotCancelled}                        
                    commands={[
                        {title: "Yes", handler: this.onSubmitBallotConfirmed}
                    ]}
                >  
                    <p>Submitting a ballot is final. No changes can be made to the ballot once you submit it.  Are you sure you want to submit the ballot now?</p>

                    {this.bConfig.needsDecision && 
                    <p>You have selected the <span style={{fontSize: "16px"}}><strong>{decision}</strong></span> team of <span style={{fontSize: "16px"}}><strong>{winners.map(x=>x.displayname).join(" & ")}</strong></span> to be the winner{winners.length > 1 ? 's' : ''}.  Would you like to submit your final ballot with this decision?</p>
                    }

                </ModalWindow>
                <ModalWindow title="Thank-you for your help with our tournament!" open={this.state.openSubmitted} onCancel={this.onSubmittedBallotCancelled}
                    content="Your ballot has been submitted. We will bring you back to the tournament page to make sure you are available for the next round and/or to check your next room assignment."
                    commands={[
                        {title: "Ok", handler: this.onSubmittedBallotCancelled}
                    ]}
                />                                
            </TournamentPageTemplate>
        )
    }
}

export default TournamentBallot
